import React from "react";
import { storyblokEditable } from "@storyblok/react";

import AiAssessment from "@components/organisms/forms/AiAssessment";

import { AiAssessmentStoryblokProps } from "./types";

const AiAssessmentStoryblok: React.FC<AiAssessmentStoryblokProps> = ({
  blok
}) => (
  <div {...storyblokEditable(blok)}>
    <AiAssessment />
  </div>
);

export default AiAssessmentStoryblok;
